<template>
  <BasicLayout>
    <template #wrapper>

      <el-card :bordered="false" :body-style="{padding: '0'}">
        <el-form :inline="true">
          <el-form-item label="平台" prop="platForm">
            <el-select v-model.number="queryParams1.platForm" size="small" style="width: 100px" placeholder="请选择">
              <el-option
                v-for="item in platForm"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="国家" prop="startDate">
            <el-select v-model="queryParams1.country" filterable size="small" style="width: 150px" placeholder="请选择">
              <el-option
                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="登录方式" prop="adChannel">
            <el-select v-model="queryParams1.adChannel" filterable placeholder="请选择">
              <el-option
                v-for="item in adChannel"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="queryParams1.startDate"
              placeholder="请选择日期"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              size="small"
              style="width: 150px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="queryParams1.endDate"
              placeholder="请选择日期"
              clearable
              value-format="yyyy-MM-dd"
              type="date"
              size="small"
              style="width: 150px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { getLoginStat } from '@/api/statistics/user_remain'
import { dateStrTodate } from '@/utils'
export default {
  name: 'IndexUserCharts2',
  data() {
    return {
      loading: false,
      platForm: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }, { label: 'TG', value: 3 }],
      adChannel: [{ label: '全部', value: '' }, { label: '游客', value: 'GUEST' }, { label: 'FACEBOOK', value: 'FACEBOOK' }, { label: '苹果', value: 'APPLE' }, { label: '谷歌', value: 'GOOGLE' }],
      country: [],
      chartData: {},
      chart: {},
      queryParams1: {
        platForm: 0,
        country: '',
        startDate: '',
        endDate: '',
        adChannel: ''
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      if (!this.queryParams1.startDate) {
        this.msgError('开始日期不能为空')
        return
      }

      if (!this.queryParams1.endDate) {
        this.msgError('结束日期不能为空')
        return
      }
      if (this.queryParams1.startDate > this.queryParams1.endDate) {
        this.msgError('开始日期不能与结束日期')
        return
      }
      this.initChart()
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.chart.showLoading()
      const option = {
        title: {
          text: '新增与活跃'
        },
        xAxis: {
          name: '',
          type: 'category',
          data: []
        },
        legend: {
          data: ['新增', '活跃'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          trigger: 'axis',
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '新增',
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 7,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              normal: {
                color: '#00BFFF' // 改变线条颜色
              }
            }
          },
          {
            name: '活跃',
            symbol: 'circle',
            symbolSize: 7,
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              normal: {
                color: 'red' // 改变线条颜色
              }
            }
          }
        ]
      }
      this.loading = true
      setTimeout(() => {
        getLoginStat(this.queryParams1).then(res => {
          this.loading = false
          this.chart.hideLoading()
          if (res.code === 200) {
            const date = []
            const regData = []
            const logData = []
            const country = res.data.country
            res.data.regData.forEach(item => {
              date.push(dateStrTodate(Object.keys(item)[0]))
              regData.push(Object.values(item)[0])
            })

            res.data.logData.forEach(item => {
              logData.push(Object.values(item)[0])
            })
            this.country = [{ value: '', label: '全部' }]
            for (const i in country) {
              this.country.push({ value: i, label: country[i] })
            }
            this.queryParams1 = res.data.req
            option.xAxis.data = date
            option.series[0].data = regData
            option.series[1].data = logData
            this.chart.setOption(option, true)
          } else {
            this.msgError(res.msg)
          }
        })
      }, 800)
    }
  }
}
</script>

<style scoped>

</style>
